import { lazier } from '@modules/shared/components';

export const RolesPage = lazier(() => import('./RolesPage'));
